<script>
import { api } from '../../../firebase'

export default {
  name: 'ImageTemplatePreview',
  props: {
    imageTemplate: { type: String, required: true },
    event: { type: String, required: true }
  },
  computed: {
    hasRendered() {
      return !!this.rendered
    },
    hasError() {
      return !!this.error
    },
    isPending() {
      return !this.hasRendered && !this.hasError
    }
  },
  data() {
    return {
      error: null,
      rendered: null
    }
  },
  async mounted() {
    await this.render({ cache: { read: true, write: true } })
  },
  methods: {
    async render({ cache } = {}) {
      try {
        this.error = null
        this.rendered = null
        const { image } = await api.imageTemplates.render({
          imageTemplate: this.imageTemplate,
          event: this.event,
          output: { format: 'png' },
          cache
        })
        this.rendered = image
      } catch (error) {
        this.error = error
      }
    },
    async reRender() {
      await this.render({ cache: { read: false, write: true } })
    }
  }
}
</script>

<template>
  <div v-if="isPending">
    <p>
      Rendering...
    </p>
  </div>
  <div v-else-if="hasError">
    <p>
      An error occurred.
    </p>
    <v-btn primary class="mt-2 mb-2" @click="reRender">Retry</v-btn>
  </div>
  <div v-else>
    <img class="rendered-image" :src="rendered" />
    <v-btn primary class="mt-2 mb-2" @click="reRender">Re-render</v-btn>
  </div>
</template>

<style lang="scss" scoped>
.rendered-image {
  width: 300px;
}
</style>
